import { Box, Typography, useTheme } from "@mui/material"

export default function ChangelogButton({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode
    let theme = useTheme()

    let changelogButtonState = params.changelogButtonState
    let setChangelogButtonState = params.setChangelogButtonState
    let userCanViewChangelog = params.userCanViewChangelog

    const changelogButtonOnClick = () => {
        if (pageMode === 'changelog') {
            setPageMode('read')
        } else if (pageMode === 'read') {
            setPageMode('changelog')
        }
    }

    const handleChangelogButtonHover = (event) => {
        event.preventDefault()
        setChangelogButtonState('hover')
    }

    const handleChangelogButtonMouseOut = (event) => {
        event.preventDefault()
        setChangelogButtonState('default')
    }

    // Only show changelog button for admin users
    if (!userCanViewChangelog) {
        return null;
    }

    let buttonColor = ''
    let buttonText = 'Changelog'
    let changelogButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled

    if (pageMode === 'read'){
        if (changelogButtonState === 'hover') buttonColor = '#108DF9'
        else if (changelogButtonState === 'default') buttonColor = '#04569D'
    }
        
    else if (pageMode === 'changelog') {
        if (changelogButtonState === 'hover') buttonColor = theme.palette.ChannelPage.subheader.grayhighlight
        else if (changelogButtonState === 'default') buttonColor = theme.palette.ChannelPage.subheader.gray
        buttonText = 'Exit'
        changelogButtonFontColor = theme.palette.ChannelPage.subheader.fontdefault
    }

    return (
        <>
            {(pageMode === 'read' || pageMode === 'changelog') && (
                <Box alignSelf={'center'} height={'35px'} width={'105px'} padding={'5px 10px'} sx={{backgroundColor: buttonColor}} 
                    onClick={changelogButtonOnClick}
                    onMouseOut={(event) => handleChangelogButtonMouseOut(event)} 
                    onMouseOver={(event) => handleChangelogButtonHover(event)}
                >
                    <Typography align={'center'} color={changelogButtonFontColor} fontSize={'18px'} fontWeight={400}>{buttonText}</Typography>
                </Box>
            )}
        </>
    )
}